import { render, staticRenderFns } from "./selectCommdity.vue?vue&type=template&id=b382795c&scoped=true"
import script from "./selectCommdity.vue?vue&type=script&lang=js"
export * from "./selectCommdity.vue?vue&type=script&lang=js"
import style0 from "./selectCommdity.vue?vue&type=style&index=0&id=b382795c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b382795c",
  null
  
)

export default component.exports